Valida = {
	email: function (e) {
		if (e.indexOf('@') == -1 || e.indexOf('.') == -1) {
			return false;
		} else {
			return true;
		}
	},
	telefone: function (e) {
		var tel = e;

		tel = tel.replace(/[^0-9]/, '');

		if (tel.length < 10)
			return false;

		return true;
	}
}

$('form#login').submit(function () {
	var campo = {
		"email": $('input[name=email]', this),
		"senha": $('input[name=senha]', this)
	}

	$('form#login .campo-erros ul li').remove();
	var erros = [];

	if (!Valida.email(campo.email.val())) {
		campo.email.addClass('is-err');
		erros.push("E-mail");
	} else {
		campo.email.removeClass('is-err');
	}

	if (!campo.senha.val().length) {
		campo.senha.addClass('is-err');
		erros.push("Senha");
	} else {
		campo.senha.removeClass('is-err');
	}

	if (erros.length !== 0) {
		$(".m-login").prev().children("h2").first().click();

		$.each(erros, function (key, val) {
			$('form#login .campo-erros ul').append("<li>Verifique o campo <strong>\"" + val + "\"</strong>.</li>");
		});
		return false;
	}
});


$('form#login-forgot').submit(function () {
	var campo = {
		"email": $('input[name=email]', this)
	}

	$('form#login .campo-erros ul li').remove();
	var erros = [];

	if (!Valida.email(campo.email.val())) {
		campo.email.addClass('is-err');
		erros.push("E-mail");
	} else {
		campo.email.removeClass('is-err');
	}

	if (erros.length !== 0) {
		$.each(erros, function (key, val) {
			$('form#login-forgot .campo-erros ul').append("<li>Verifique o campo <strong>\"" + val + "\"</strong>.</li>");
		});
		return false;
	}
});


$('form#cadastro').submit(function (e) {
	e.preventDefault();

	var campo = {
		"nome": $('input[name=nome]', this),
		"email": $('input[name=email]', this),
		"emailb": $('input[name=emailb]', this),
		"telefone": $('input[name=telefone]', this)
	}

	campo.email.on("input", function () {
		$('.box.boxAccordion').last().removeClass("email-existe");
		$('.box.boxAccordion p.success').remove();
	});

	campo.emailb.on("input", function () {
		$('.box.boxAccordion').last().removeClass("email-existe");
		$('.box.boxAccordion p.success').remove();
	});

	$('form#cadastro .campo-erros ul li').remove();
	var erros = [];

	if (campo.nome.val().length < 3) {
		campo.nome.addClass('is-err');
		erros.push("Nome Completo");
	} else {
		var nome_completo;

		nome_completo = campo.nome.val().split(' ');

		if (nome_completo.length >= 2) {
			campo.nome.removeClass("is-err");
		} else {
			campo.nome.addClass('is-err');
			erros.push("Nome Completo");
		}
	}

	if (!Valida.email(campo.email.val())) {
		campo.email.addClass('is-err');
		erros.push("E-mail");
	} else {
		campo.email.removeClass('is-err');
	}

	if (campo.email.val() !== campo.emailb.val()) {
		campo.emailb.addClass('is-err');
		erros.push("Confirme o E-mail");
	} else {
		campo.emailb.removeClass('is-err');
	}

	if (!Valida.telefone(campo.telefone.val())) {
		campo.telefone.addClass('is-err');
		erros.push("Telefone");
	} else {
		campo.telefone.removeClass('is-err');
	}

	if (erros.length !== 0) {
		$.each(erros, function (key, val) {
			$('form#cadastro .campo-erros ul').append("<li>Verifique o campo <strong>\"" + val + "\"</strong>.</li>");
		});
		return false;
	}

	else {
		$.ajax({
			url: $(this).attr('action'),
			method: "POST",
			data: $(this).serialize(),
			success: function (data) {
				if (typeof JSON.parse(data).message !== "undefined") {
					if (!$('.box.boxAccordion p.success').length) {
						$('.box.boxAccordion').last().prepend('<p class="success">' + JSON.parse(data).message + '</p>');
					}

					$('.box.boxAccordion').last().addClass("email-existe");
				} else {
					window.location.href = JSON.parse(data).url;
				}
			}
		});
	}
});


$('form#atualizar').submit(function () {
	var campo = {
		"nome": $('input[name=nome]', this),
		"email": $('input[name=email]', this),
		"telefone": $('input[name=telefone]', this),
		"celular": $('input[name=celular]', this),
		"cnpjcpf": $('input[name=cnpjcpf]', this)
	}

	$('form#atualizar .campo-erros ul li').remove();
	var erros = [];

	if (campo.nome.val().length < 3) {
		campo.nome.addClass('is-err');
		erros.push("Nome Completo");
	} else {
		var nome_completo;

		nome_completo = campo.nome.val().split(' ');

		if (nome_completo.length >= 2) {
			campo.nome.removeClass("is-err");
		} else {
			campo.nome.addClass('is-err');
			erros.push("Nome Completo");
		}
	}

	if (!Valida.email(campo.email.val())) {
		campo.email.addClass('is-err');
		erros.push("E-mail");
	} else {
		campo.email.removeClass('is-err');
	}


	if (campo.telefone.val().length < 8) {
		campo.telefone.addClass('is-err');
		erros.push("Telefone");
	} else {
		campo.telefone.removeClass("is-err");
	}

	if (erros.length !== 0) {
		$.each(erros, function (key, val) {
			$('form#atualizar .campo-erros ul').append("<li>Verifique o campo <strong>\"" + val + "\"</strong>.</li>");
		});
		return false;
	}
});

$('form#atualizarsenha').submit(function () {
	var campo = {
		"senha": $('input[name=senha]', this),
		"senhab": $('input[name=senhab]', this)
	}

	$('form#atualizarsenha .campo-erros ul li').remove();
	var erros = [];

	if (!campo.senha.val()) {
		campo.senha.addClass('is-err');
		erros.push("Digite a nova senha");
	} else if (campo.senha.val().length < 4) {
		campo.senha.addClass('is-err');
		erros.push("A senha deve possuir no mínimo 4 caracteres");
	} else {
		campo.senha.removeClass('is-err');
	}

	if (campo.senha.val() !== campo.senhab.val()) {
		campo.senhab.addClass('is-err');
		erros.push("Confirme a nova senha");
	} else {
		campo.senhab.removeClass('is-err');
	}

	if (erros.length !== 0) {
		$.each(erros, function (key, val) {
			$('form#atualizarsenha .campo-erros ul').append("<li>Verifique o campo <strong>\"" + val + "\"</strong>.</li>");
		});
		return false;
	}
});

/*
	Signin com o Google
*/

function onSignIn(response) {

	var id_token = response.getAuthResponse().id_token;

	var xhr = new XMLHttpRequest();

	xhr.open('POST', $(".logo").attr("href") + "login/googletokensignin");
	xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
	xhr.onload = function () {
		try {
			var data = JSON.parse(xhr.responseText);
			window.location.href = data.url;
		} catch (erro) { }
	};
	xhr.send('idtoken=' + id_token);
};

document.querySelectorAll(".btn.google").forEach(function (e) {
	e.onclick = function (evt) {
		evt.preventDefault();
		document.querySelectorAll(".abcRioButtonContents span")[0].click();
	}
});

/*
	Mostra formulários de login/signin quando da erro
*/

$(document).ready(function(){
	if($(".campo-erros").first().find("li").length){
		$(".m-login").prev().children("h2").first().click();
	}

	if($(".campo-erros").last().find("li").length){
		$(".m-cadastro").prev().children("h2").first().click();
	}
});